export default __webpack_public_path__ + "f1cbc30f2519b4bbe23fa878926e3d92.png";